<li>
  <a
    [routerLink]="link"
    routerLinkActive="active"
    [class.active]="active"
    class="mb-xs flex h-full w-full cursor-pointer items-center px-sm py-xs font-medium"
  >
    @if (dynamicIcon) {
      <cft-dynamic-icon [icon]="dynamicIcon"></cft-dynamic-icon>
    }
    @if (faIcon) {
      <fa-icon [icon]="faIcon"></fa-icon>
    }
    @if (isOpen) {
      <span class="item-label ml-xs">
        {{ name }}
      </span>
      @if (chip) {
        <cft-chip
          class="item-tag ml-auto w-auto max-w-[2.5rem]"
          [overflow]="false"
          padding="sm"
          size="sm"
          [colour]="chip.colour"
          >{{ chip.text }}</cft-chip
        >
      }
    }
  </a>
</li>
